module.exports = __webpack_public_path__ + "dde011cfa688a4f3b03ca7449fd27528.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2040_teaser_image.jpg
// module id = 576
// module chunks = 0